module.exports = __webpack_public_path__ + "static/carbon-table-expandable-d9e2cb0e6dd74d58d17db7b481fbbe68.png";